import type {
  ListExternalLayersQuery,
  ListExternalLayersFilter,
} from 'hooks/externalLayer/types';
import { buildSearchQueryParams } from 'hooks/shared/buildSearchQueryParams';

export const externalLayersKeys = {
  all: () => ['external_layers'] as const,
  list: (query: ListExternalLayersQuery) => {
    const params = buildSearchQueryParams<ListExternalLayersFilter>(query);
    return [...externalLayersKeys.all(), 'list', params] as const;
  },
};
